import { WOW } from 'wowjs'

if (window !== undefined) {

  window.WOW = WOW
}
